import { Matcher } from '@codeleap/types'

const keys: Matcher<'key'>[] = [
  'email',
  'first_name',
  'last_name',
  'name',
  'avatar',
  'password',
]

const values: Matcher<'value'>[] = [
  /Cacetinho/,
]

export const obfuscate = {
  keys,
  values,
}